import Reveal from "@/components/home/Reveal";
import { useLeadForm } from "@/components/home/leadForm";
import { CheckCircle2, MessageCircle } from "lucide-react";

export const FinalCTA = () => {
  const lf = useLeadForm({}, { requireRestaurant: false });
  const onSubmit = (e) => { e.preventDefault(); lf.submit("cta-final-form"); };

  return (
    <section id="empezar" className="mt-section bg-brand-orange text-white relative overflow-hidden" data-testid="final-cta-section">
      <div className="absolute inset-0 opacity-20 pointer-events-none" style={{ backgroundImage: "radial-gradient(circle at 20% 20%, #fff 0, transparent 35%), radial-gradient(circle at 85% 80%, #fff 0, transparent 30%)" }} />
      <div className="mt-container relative text-center">
        <Reveal>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl leading-tight max-w-3xl mx-auto">Empieza hoy. Alta express en minutos y 0% de comisión.</h2>
          <p className="mt-4 text-base md:text-lg text-white/90 font-medium">Plan Free gratis para siempre · Lite y Pro con 7 días de prueba · Cancela cuando quieras.</p>
        </Reveal>
        <Reveal delay={120} className="mt-10 max-w-4xl mx-auto">
          {lf.status.done ? (
            <div className="rounded-3xl bg-white text-brand-carbon p-8" data-testid="final-cta-success">
              <CheckCircle2 className="w-12 h-12 text-brand-green mx-auto" />
              <p className="mt-3 font-heading font-bold text-2xl">¡Listo, {lf.form.name.split(" ")[0]}! Te abrimos WhatsApp.</p>
              <p className="mt-1 text-gray-600">Si no se abrió, toca el botón:</p>
              <a href={lf.status.done.url} target="_blank" rel="noopener noreferrer" className="btn-mt btn-mt-wa mt-5" data-testid="final-cta-success-wa-link"><MessageCircle className="w-5 h-5" /> Abrir WhatsApp</a>
            </div>
          ) : (
            <form onSubmit={onSubmit} noValidate className="rounded-3xl bg-white p-4 sm:p-5 grid gap-3 lg:grid-cols-[1fr_1fr_1fr_auto] text-left shadow-2xl" data-testid="final-cta-form">
              {[["name", "Nombre", "Tu nombre", "text"], ["whatsapp", "WhatsApp", "10 dígitos", "tel"], ["city", "Ciudad", "Tu ciudad", "text"]].map(([k, label, ph, type]) => (
                <label key={k} className="block">
                  <span className="sr-only">{label}</span>
                  <input type={type} placeholder={`${label} · ${ph}`} value={lf.form[k]} onChange={lf.set(k)} className={`mt-input ${lf.errors[k] ? "error" : ""}`} data-testid={`final-cta-${k}-input`} inputMode={k === "whatsapp" ? "numeric" : undefined} />
                  {lf.errors[k] && <span className="text-xs text-red-600 mt-1 block">{lf.errors[k]}</span>}
                </label>
              ))}
              <button type="submit" className="btn-mt btn-mt-primary !w-full lg:!w-auto whitespace-nowrap" disabled={lf.status.sending} data-track="cta-final-submit" data-testid="final-cta-submit-button">Activar mi restaurante</button>
            </form>
          )}
          <p className="mt-4 text-sm text-white/80">Al enviar se abre WhatsApp con tu mensaje listo para Richard Gower.</p>
        </Reveal>
      </div>
    </section>
  );
};

export default FinalCTA;
